export const WorkData = [
    {
        company:"1) Worked on freelancing project",
        Designation :"Frontend developer",
        // date: "1-1-2000",
        // Dateend>: "1-2-3300",
        Work: "Created UI for a stock trading app.The role also included fetching the data from backend and display it on UI",
        // companyLogo:"../Assets/restaurant.png"
    },
    {
        company:"2) Created hulu clone for hactoberfest 2020",
        Designation :"Frontend developer",
        // date: "1-1-2000",
        // Dateend>: "1-2-3300",
        Work: "Made a working clone of hulu web app for hacktoberfest 2020.The pull request was successfully merged.",
        // companyLogo:"../Assets/restaurant.png"
    },
    {
        company:"3) Made open source contribution in hactoberfest 2022",
        Designation :"Frontend developer",
        // date: "1-1-2000",
        // Dateend>: "1-2-3300",
        Work: "Created and curated website that provides resources for web develoment.",
        // companyLogo:"../Assets/restaurant.png"
    },
    {
        company:"4) Coded and made a website live for local restaurant",
        Designation :"Frontend developer",
        // date: "1-1-2000",
        // Dateend>: "1-2-3300",
        Work: "A group project done for local Bangalore restaurant.My role was to design and code the about us as well as the home page for the restaurant's website.",
        // companyLogo:"../Assets/restaurant.png"
    }
    

]